<template lang="html">
	<div :class='locked ? "action-list locked" : "action-list"'>
		<!-- <pre>{{data}}</pre> -->

		<div class="row">
			<div class="cols s_24">
				<template v-if='!items.length'>
					{{ data.nothing_to_show }}
				</template>

				<template v-else>
					<ul class="grid s_1 m_2 l_3">
						<li v-for='item in items'>
							<div class="item">
								<a :href="item.href" :style='`background-image: url(${item.image_src})`' class="imgContainer">

									<p class="data">{{item.data}}</p>
									<p class="text">{{item.text}}</p>
								</a>
							</div>

						</li>
					</ul>
				</template>

			</div>
		</div>

	</div>
</template>

<script>
module.exports = {
	props: ['data', 'merge', 'locked'],

	data() {
		return {
			items: []
		}
	},

	watch: {
		data() {
			// this.items = ;
			if(this.merge) {
				console.log(this.items);
				this.data.items.forEach(item => this.items.push(item));
			}
			else {
				this.items = this.data.items;
			}
		}
	},

	updated() {
		if(!this.merge) {
			$('html, body').stop().animate({
				// scrollTop: $(this.$el).offset().top - 100
			});
		}
	}
}
</script>

<style lang="scss">
@import "scss/wanted";

.action-list {
	@include single-transition;
	margin: 0 0 30px;

	&.locked {
		opacity: .5;
	}
	.item {
		box-shadow: 0px 2px 10px 0px rgba(#000, 0.1);
		border-radius: 5px;
		height: 250px;
		overflow: hidden;
		@include single-transition();
		&:hover{
			box-shadow: 0px 5px 15px 0px #333;
		}
		a{
			display: flex;
			flex-direction: column;
			padding: rem(20);
			height: 100%;
			justify-content: flex-end;
			text-decoration: none;
			background-size: cover;
			@include m_up{
				padding: rem(24) rem(29);
			};
			.data{
				position: relative;
				padding-left: rem(23);
				font-size: rem(13);
				line-height: rem(18);
				margin-bottom: rem(12);
				display: inline-block;
				color: #fff;
				// margin-left: -20px;
				@include m_up{
					margin-left: 0;
				};
				&:before{
					position: absolute;
					left: 0;
					top: calc(50% - 8px);
					width: 15px;
					height: 15px;
					content: "";
					background-image: url('#{$imgPathSCSS}calendar.svg');
					background-size: contain;
					filter: invert(1);
				}
			}
			.text{
				font-size: rem(15);
				line-height: 25px;
				max-height: 78px;
				overflow: hidden;
				color: #fff;
				text-decoration: none;
				display: block;
				&:hover{
					text-decoration: underline;
					text-decoration-color: rgba(#fff, .5);
				}
			}
		}
	}
	.more{
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: row;
		height: 3rem;
		text-align: center;
		text-decoration: none;
		cursor: pointer;
		border: none;
		outline: none;
		margin: 0 auto 30px;
		user-select: none;
		transition: all .3s ease;
		font-family: ProximaNova-Bold;
		letter-spacing: 1px;
		font-size: 11px;
		color: #fff;
		width: 190px;
		background-color: #0072ff;
		box-shadow: 0 5px 30px 0 rgba(0,0,0,.4);
		text-transform: uppercase;
		border-radius: 30px;
	}

}
</style>



// WEBPACK FOOTER //
// default.vue?25c32554